import { createContext, useState, useEffect, useContext, useCallback } from "react";
import { fetchUserThreads } from "../services/api";

export const ThreadContext = createContext();

export const ThreadProvider = ({ children }) => {
  const [threads, setThreads] = useState([]);
  const [threadId, setThreadId] = useState(null); // 🔧 Добавено

  const updateThreadList = useCallback(async () => {
    const data = await fetchUserThreads();
    setThreads(data);
    localStorage.setItem("threads", JSON.stringify(data));
  }, []);

  useEffect(() => {
    updateThreadList();
  }, [updateThreadList]);

  return (
    <ThreadContext.Provider
      value={{
        threads,
        updateThreadList,
        threadId,
        setThreadId, // 🔧 Добавено
      }}
    >
      {children}
    </ThreadContext.Provider>
  );
};

export const useThreadContext = () => useContext(ThreadContext);
